import * as React from "react"
export const Svg_034 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M10.195 20.345h4.532v3.457h-4.532v-3.457Z" />
    <path
      fill="url(#b)"
      d="M0 9.974v39.052h58V9.974H0Zm6.797 6.914h11.328v10.371H6.797V16.888Zm3.398 25.224H6.797v-3.457h3.398v3.457Zm6.797 0h-3.398v-3.457h3.398v3.457Zm6.797 0h-3.398v-3.457h3.398v3.457Zm6.797 0h-3.398v-3.457h3.398v3.457Zm13.82 0h-3.398v-3.457h3.398v3.457Zm6.797 0h-3.398v-3.457h3.398v3.457Zm0-6.914H6.797v-3.457h44.406v3.457Zm0-14.853H41.008v-3.457h10.195v3.457Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={11.243}
        x2={12.659}
        y1={20.863}
        y2={23.868}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.412}
        x2={28.124}
        y1={15.832}
        y2={51.194}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)